import React, { useEffect } from "react";

import Preloader from "../components/Miscellaneous/Preloader";
import Header from "../components/Header/Header";
import PortfolioSection from "../components/Portfolio/casapalmira";
import CTA from "../components/CTA/CTAOne";
import Footer from "../components/Footer/Footer";
import SearchModal from "../components/Miscellaneous/SearchModal";
import OffcanvasMenu from "../components/Miscellaneous/OffcanvasMenu";
import MagicCursor from "../components/Miscellaneous/MagicCursor";
import LenisScroll from "../components/Header/LenisScroll";

const CasaPalmira = () => {
  useEffect(() => {
    // Prevent "null.classList" error if DOM not ready
    const wrapper = document.getElementById("main-wrapper");
    if (wrapper) {
      wrapper.classList.add("page-loaded");
    }
  }, []);

  return (
    <div>
      <MagicCursor />
      <Preloader />
      <LenisScroll />
      <div className="main">
        <Header />
        <div id="main-wrapper" className="main-wrapper">
          <PortfolioSection />
          <CTA />
          <Footer />
          <SearchModal />
          <OffcanvasMenu />
        </div>
      </div>
    </div>
  );
};

export default CasaPalmira;
